var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 16.6667H31.2732C33.7512 16.6667 35.3628 19.2744 34.2546 21.4907L28.4213 33.1574C27.8567 34.2867 26.7025 35 25.4399 35H18.7437C18.4711 35 18.1996 34.9666 17.9352 34.9005L11.6667 33.3333M23.3333 16.6667V8.33333C23.3333 6.49238 21.8409 5 20 5H19.8409C19.0083 5 18.3333 5.67495 18.3333 6.50754C18.3333 7.69805 17.9809 8.86192 17.3206 9.85248L11.6667 18.3333V33.3333M23.3333 16.6667H20M11.6667 33.3333H8.33333C6.49238 33.3333 5 31.841 5 30V20C5 18.1591 6.49238 16.6667 8.33333 16.6667H12.5",
    stroke: "#434289",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.3335af5c7111af56025b011297bb9836.svg";
export { ForwardRef as ReactComponent };